export const scanInfo = [
    'scanner_scan', 'camera_scan', 'double_scan', 'clear_scan', 'write_badge_code'
]